import { render, staticRenderFns } from "./columnTabs.vue?vue&type=template&id=16171b66&scoped=true&"
import script from "./columnTabs.vue?vue&type=script&lang=js&"
export * from "./columnTabs.vue?vue&type=script&lang=js&"
import style0 from "./columnTabs.vue?vue&type=style&index=0&id=16171b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16171b66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems,VTooltip})
